import React from 'react';

export default function MultiLineTextDisplay({text, ...rest}) {
  return(
    <div className={rest.className ? rest.className : "mb-3"}>
      {text && text.split("<br>").map((x,index) => x === "" ? <br/> : <p key={index} className={(rest.textClassName ? rest.textClassName : "")}>{x}</p>)}
    </div>
  )
}
